export default function () {
  document.addEventListener('DOMContentLoaded', () => {
    const menusHandlers = document.querySelectorAll('.menu-accordion__trigger');
    const menusWpapperClass = '.menu-accordion__wrapper';
    const menuElClass = '.menu-accordion__panel';

    menusHandlers.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        const menuWrapper = item.closest(menusWpapperClass);
        const menuPanel = menuWrapper.querySelector(menuElClass);

        if (!item.classList.contains('active')) {
          item.classList.add('active');
          menuPanel.style.display = 'block';
        } else {
          item.classList.remove('active');
          menuPanel.style.display = 'none';
        }
      });
    });
  });
}
